<template>
  <img :key="attempt" :src="failed ? fallback : src || fallback" :data-artwork-attempt="attempt" :data-artwork-state="failed ? 'fallback' : src ? 'source' : 'empty'" @error="onError" />
</template>
<script>
// Keep failures local to an image attempt, so a refreshed URL or restored
// network can recover without changing the original (possibly signed) URL.
export default {
  name: 'ArtworkImage',
  props: { src: { type: String, default: '' }, fallback: { type: String, required: true }, retryKey: { type: [String, Number], default: '' } },
  data() { return { failed: false, attempt: 0, retryReason: '' }; },
  watch: { src() { this.retry(); }, retryKey() { this.retry(); } },
  mounted() { window.addEventListener('online', this.onOnline); },
  beforeDestroy() { window.removeEventListener('online', this.onOnline); },
  methods: {
    onError(event) {
      if (this.failed || !this.src || this.src === this.fallback) return;
      // A removed image can finish after a new source/version was rendered.
      const image = event?.currentTarget;
      if (image && (image.getAttribute('src') !== this.src || Number(image.dataset.artworkAttempt) !== this.attempt)) return;
      this.failed = true;
      this.$emit('source-error', { src: this.src, retryKey: this.retryKey, retryReason: this.retryReason });
    },
    retry(reason = '') { this.failed = false; this.attempt++; this.retryReason = reason; },
    onOnline() { if (this.failed) this.retry('online'); },
  },
};
</script>
